import emailjs from "@emailjs/browser";
import { useCallback, useMemo, useRef, useState } from "react";
import config from "../../../config/config";
import resetForm from "../../../helpers/resetForm";
import "./index.scss";

const {
  emailConfig: { public_key, service_id, template_id },
} = config;

const ContactForm = () => {
  const formRef = useRef(null);
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");

  const submitData = useMemo(() => {
    return {
      from_name: name,
      from_email: email,
      message,
    };
  }, [name, email, message]);

  const submitForm = useCallback(
    async (e) => {
      e.preventDefault();
      try {
        await emailjs.send(service_id, template_id, submitData, public_key);
        resetForm([setName, setEmail, setMessage]);
      } catch (err) {
        throw new Error(err.message);
      }
    },
    [submitData]
  );

  return (
    <form ref={formRef} onSubmit={submitForm}>
      <div className="contact-info">
        <h1>
          Let me know if you want to talk about a potential collaboration. I'm
          available for freelance work.
        </h1>
        <p>jshaykdeveloper@gmail.com</p>
      </div>
      <div className="contact-fields">
        <input
          value={name}
          onChange={(e) => setName(e.target.value)}
          type="text"
          placeholder="What’s your name?"
        />
        <input
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          name="from_email"
          type="text"
          placeholder="Your email"
        />
        <textarea
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          name="message"
          placeholder="Tell me about your project"
        ></textarea>
      </div>
      <button onClick={submitForm} type="button">
        Send
      </button>
    </form>
  );
};

export default ContactForm;
